import {isValidPhoneNumber} from 'libphonenumber-js';
import {BicSwiftRegexp, EmailRegexp, IbanRegexp} from '../regexp';

const lengthFieldMessage = ({translation, value, type = 'min'}) =>
  translation(`main:validation.${type}LengthValidation`, {value});

const buildValidation = (t, required, { pattern, messageKey }) => {
  if (!t) return [];

  const rules = [{ pattern, message: t(messageKey) }];
  return required ? [...validation.required(t), ...rules] : rules;
};

export const validation = {
  bic: (t, required = true) =>
    buildValidation(t, required, {
      pattern: BicSwiftRegexp,
      messageKey: 'validation.bicSwiftValidation',
    }),

  iban: (t, required = true) =>
    buildValidation(t, required, {
      pattern: IbanRegexp,
      messageKey: 'validation.ibanValidation',
    }),

  email: (t, required = true) =>
    buildValidation(t, required, {
      pattern: EmailRegexp,
      messageKey: 'validation.enterValidEmail',
    }),

  password: (t, length = 6) => {
    if (!t) return [];

    return [
      ...validation.required(t),
      {min: length, message: lengthFieldMessage({translation: t, value: length, type: 'min'})},
      {max: length, message: lengthFieldMessage({translation: t, value: length, type: 'max'})},
      () => ({
        validator(_, value) {
          const reg = /^-?\d*(\.\d*)?$/;
          if (reg.test(value) || value === '') {
            return Promise.resolve();
          }
          return Promise.reject(new Error(t('validation.decimalValidation')));
        },
      })
    ];
  },

  passwordConfirm: (t, length = 6, firstPasswordFieldName = 'first_password') => {
    return [
      ...validation.password(t, length),
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (!value || getFieldValue(firstPasswordFieldName) === value) {
            return Promise.resolve();
          }
          return Promise.reject(new Error(t('validation.passwordsDoNotMatch')));
        },
      }),
    ]
  },

  phone: (t, required = true) => {
    if (!t) return [];

    const rules = [
      {
        message: t('auth:validation.phoneIsIncorrect'),
        validator: (_, value) =>
          required
            ? isValidPhoneNumber(value) ? Promise.resolve() : Promise.reject()
            : Promise.resolve(),
      },
    ];

    return required ? [...validation.required(t), ...rules] : rules;
  },

  required: (t) => {
    if (!t) return [];
    return [
      {
        required: true,
        message: t('validation.fieldIsRequired'),
      },
    ];
  },

  vat: (t, required = true) => {
    if (!t) return [];

    const rules = [
      {
        min: 4,
        message: lengthFieldMessage({ translation: t, type: 'min', value: 4 }),
      },
      {
        max: 15,
        message: lengthFieldMessage({ translation: t, type: 'max', value: 15 }),
      },
    ];

    return required ? [...validation.required(t), ...rules] : rules;
  },
};